// angular
import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ITender } from '@tenders/shared/interfaces/tender.interface';
import { TranslateDataPipe } from '@app/shared/pipes/translate-data.pipe';

@Component({
  selector: 'pwj-tender-delivery-tab',
  standalone: true,
  imports: [TranslateModule, TranslateDataPipe],
  templateUrl: './tender-delivery-tab.component.html',
  styleUrl: './tender-delivery-tab.component.scss',
})
export class TenderDeliveryTabComponent {
  tender = input.required<ITender>();
}
